import React from "react"
import { StyledItem } from "./partials"

export interface ItemProps {
  title: string
}

export const ItemCmp: React.FC<ItemProps> = ({
  title,
}) => (
  <StyledItem
  >
    <p>{title}</p>
  </StyledItem>
)

export default ItemCmp